<template>
    <div>
        <!-- <base-header type="gradient-success" class="pb-6 pt-6 pt-md-2">

        </base-header>--> 
        <div class="card shadow">
            <div class="bg-transparent p-0 m-0">
                <div md="10" class="d-flex justify-content-between">
                  <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>
              <!-- 
                    <button 
                      type="button"    
                      @click="hasHistory() 
                        ? $router.go(-1) 
                        : $router.push('/')" class="btn btn-secondary btn-sm"> <span class=""> &laquo; </span>
                       {{$t('message.backtap')}}
                    </button> -->
                  <h3 class="title">
                        {{ $tc('message.donneesAffiliation', 1) }}
                    </h3>
                    
                </div>
                <b-row class="card-footer addpatient mb-2">
                  <div class="col-6 col-md p-0 m-0">
                    <b-button class="btn btn-link bg-transparent p-0 m-0 border-0" @click="viewConsentementPatient" v-if="this.signer">
                        <i class="fa fa-print"></i> {{ $t('message.Consentement') }}
                    </b-button>
                  </div>
                  <div class="col-6 col-md p-0 m-0">
                    <b-button class="btn btn-link bg-transparent p-0 m-0  border-0" @click="viewTrajetPatient">
                        <img src="/img/icons/icone_navbar/parcours_soins.png" class="" alt="Parcours de soins" width="20">
                        {{ $t('message.Trajet') }}
                    </b-button>
                  </div>
                  <div class="col-6 col-md p-0 m-0" v-if="hasAssistante && cloture.ama == null">
                    <b-button class="my-2 btn-link text-danger bg-transparent p-0 m-0 border-0" @click="cloturerContract">
                        <i class="fa fa-times"></i>
                        {{ $t('message.cloturer') }}
                    </b-button>
                  </div>
                  <div class="col-6 col-md p-0 m-0" v-if="hasAssistante">
                    <b-button class="my-2 btn-link text-warning bg-transparent p-0 m-0  border-0" v-if="getValue(mContract.status_contrat) != 'Suspendu'" @click="suspendreContract">
                          <i class="fa fa-pause"></i>
                          {{ $t('message.suspendre') }}
                      </b-button>
                       <b-button class="my-2 border-0" variant="outline-success" v-else @click="activeContract">
                        {{ $t('message.activeContrat') }}
                    </b-button>
                  </div>
                  
                  <div class="col-6 col-md p-0 m-0">
                      <b-button class="btn btn-link text-primary bg-transparent p-0 m-0 border-0" @click="viewMedicalFile">
                          <img src="/img/icons/icone_navbar/dossier_medical.png" class="mr-2" alt="Dossier medical" width="20">
                          {{ $t('message.medicalFile') }}
                      </b-button>
                  </div>
                  <div class="col-6 col-md p-0 m-0">
                      <b-button class=" btn-link text-primary bg-transparent p-0 m-0 border-0" @click="renewContrat" v-if="mContract.expire!=0">
                        <i class="fa fa-plus-circle"></i>
                          {{ $t('message.renouvelle') }}
                      </b-button>
                      <b-button class=" btn-link text-primary bg-transparent p-0 m-0 border-0" @click="extraContrat" v-else-if="getValue(mContract.status_paiement) != 'NON PAYE'">
                        <i class="fa fa-plus-circle"></i>
                        {{ $t('message.prolonger') }}
                      </b-button>
                      <b-button class=" btn-link text-primary bg-transparent p-0 m-0 border-0" @click="extraContrat" v-else-if="getValue(mContract.status_paiement) == 'NON PAYE'">
                          Payer Maintenant
                      </b-button>
                  </div>
                 <div class="col-6 col-md p-0 m-0">
                    <b-button v-b-modal.delete-modal class="btn-link text-danger bg-transparent p-0 mt-2 mt-sm-0 border-0">
                      <i class="fa fa-trash"></i>
                        {{ $t('message.resilierContrat') }}
                    </b-button>
                  </div>
                 
                </b-row>
            </div>

            <div :class="[ mobileView ? 'pt-3 p-0': 'card-body']">
                    <b-row class="p-0">
                        <b-col class="p-0">
                          <b-container fluid class="addpatient p-0">
                            <div class="p-1em">
                                <h3 class="card-title text-left mb-0 secondary-title">
                                    {{ $tc('message.informationAffilie', 2) }}
                                </h3>
                            </div>                         
                              <div class="list-group list-group-flush p-0">
                                  <b-row>

                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.lastName') }}:

                                              <span class="font-weight-bold">
                                      {{ mContract.patient.user == null ? '' : getValue(mContract.patient.user.nom) }}
                                  </span>
                                          </div>
                                      </b-col>

                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.firstName') }}:

                                              <span class="font-weight-bold">
                                                {{ mContract.patient.user == null ? '' : getValue(mContract.patient.user.prenom) }}
                                              </span>
                                          </div>
                                      </b-col>

                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.email') }}:

                                              <span class="font-weight-bold">
                                      {{ mContract.patient.user == null ? '' : getValue(mContract.patient.user.email) }}
                                  </span>
                                          </div>
                                      </b-col>
                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.phoneNumber') }}:

                                              <span class="font-weight-bold">
                                      {{ mContract.patient.user == null ? '' : getValue(mContract.patient.user.telephone) }}
                                  </span>
                                          </div>
                                      </b-col>
                                  </b-row>
                                  <b-row>
                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.gender') }}:

                                              <span class="font-weight-bold">
                                                {{ mContract.patient.sexe }}
                                              </span>
                                          </div>
                                      </b-col>
                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.decede') }}:
                                              <span v-if="mContract.patient.user.decede.toLowerCase() == 'non'" class="text-primary font-weight-bold">
                                                 {{ mContract.patient.user.decede }}
                                              </span>
                                              <span v-else class="text-danger font-weight-bold">
                                                 {{ mContract.patient.user.decede }}
                                              </span>
                                          </div>
                                      </b-col>
                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.lienParente') }}:
                                              <span class="font-weight-bold">
                                                  {{ mContract.patient.financeurs.length == 0 ? 'Autres': (mContract.patient.financeurs[0].lien == null ? 'Autres' : mContract.patient.financeurs[0].lien.fr_description) }}
                                              </span>
                                          </div>
                                      </b-col>
                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.dob') }}:

                                              <span class="font-weight-bold">
                                      {{ mContract.patient.user == null ? '' : getValue(mContract.patient.date_de_naissance) }}
                                  </span>
                                          </div>
                                      </b-col>
                                  </b-row>
                                  <b-row>
                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.nationality') }}:

                                              <span class="font-weight-bold">
                                       {{ mContract.patient.user == null ? '' : getValue(mContract.patient.user.nationalite) }}
                                  </span>
                                          </div>
                                      </b-col>
                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $tc('message.countries', 1) }}:

                                              <span class="font-weight-bold">
                                       {{ mContract.patient.user == null ? '' : getValue(mContract.patient.user.pays) }}
                                  </span>
                                          </div>
                                      </b-col>
                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $tc('message.cities', 1) }}:

                                              <span class="font-weight-bold">
                                      {{ mContract.patient.user == null ? '' : getValue(mContract.patient.user.ville) }}
                                  </span>
                                          </div>
                                      </b-col>

                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.street') }}:

                                              <span class="font-weight-bold">
                                                   {{ mContract.patient.user == null ? '' : getValue(mContract.patient.user.quartier) }}
                                  </span>
                                          </div>
                                      </b-col>

                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.zipCode') }}:

                                              <span class="font-weight-bold">
                                                   {{ mContract.patient.user == null ? '' : getValue(mContract.patient.user.code_postal) }}
                                  </span>
                                          </div>
                                      </b-col>


                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $tc('message.address') }}:

                                              <span class="font-weight-bold">
                                       {{ mContract.patient.user == null ? '' : getValue(mContract.patient.user.adresse) }}
                                      
                                  </span>
                                          </div>
                                      </b-col>

                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $tc('message.paye_par_affilie') }}:
                                              <span class="font-weight-bold">
                                                  {{ mContract.paye_par_affilie }}
                                              </span>
                                          </div>
                                      </b-col>
                                      <b-col col sm="" v-if="mContract.motifs.length > 0" class="list-group-item">
                                          <div >
                                            Plaintes:
                                            <ul>
                                              <li v-for="motif in mContract.motifs" :key="'motif_'+motif.id"><span class="font-weight-bold">{{ motif.description }}</span></li>
                                            </ul>
                                          </div>
                                      </b-col>
                                       <b-col col sm="" v-else>
                                          <div class="">
                                              Plainte:
                                              <span class="font-weight-bold">
                                                  {{ mContract.plainte }}
                                              </span>
                                          </div>
                                      </b-col>
                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.lastName') }} de la personne à contacter:
                                              <span class="font-weight-bold">
                                                  {{ mContract.contact_name }}
                                              </span>
                                          </div>
                                      </b-col>
                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.firstName') }} de la personne à contacter:
                                              <span class="font-weight-bold">
                                                  {{ mContract.contact_firstName }}
                                              </span>
                                          </div>
                                      </b-col>
                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.phoneNumber') }} de la personne à contacter:
                                              <span class="font-weight-bold">
                                                  {{ mContract.contact_phone }}
                                              </span>
                                          </div>
                                      </b-col>
                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.canalmed') }}
                                              <span class="font-weight-bold" v-if="mContract.selected == null" >
                                                  Aucun
                                              </span>
                                              <span class="font-weight-bold" v-if="mContract.selected == 1" >
                                                  Recommandattion d'un client
                                              </span>
                                              <span class="font-weight-bold" v-if="mContract.selected == 2">
                                                  WhatsApp
                                              </span>
                                              <span class="font-weight-bold" v-if="mContract.selected == 3">
                                                  Website
                                              </span>
                                              <span class="font-weight-bold" v-if="mContract.selected == 4">
                                                  Facebook
                                              </span>
                                              <span class="font-weight-bold" v-if="mContract.selected == 5">
                                                  Connaissance promoteur
                                              </span>


                                                                  <!-- { value: null, text: "Aucun" },
                    { value: 1, text: "Recommandattion d'un client" },
                    { value: 2, text: "WhatsApp" },
                    { value: 3, text: "Website" },
                    { value: 4, text: "Facebook" },
                    { value: 5, text: "Connaissance promoteur" }, -->
                                          </div>
                                      </b-col>
                                      <!-- <b-col col sm="12" v-if="hasAssistante">
                                        <div class="list-group-item">
                                          {{ $t('message.decede') }}
                                          <span class="font-weight-bold">{{mContract.user.decede}}</span> 
                                        </div>
                                       </b-col> -->
                                      
                                  </b-row>
                              </div>
                          </b-container>
                        </b-col>
                        <b-col>
                          <b-container fluid class="p-0">
                          <div class="card-body p-1em">
                              <h3 class="card-title text-left mb-0 secondary-title">
                                  {{ $tc('message.informationContrat', 2) }}
                              </h3>
                          </div>         
                              <div class="list-group list-group-flush p-0">
                                  <b-row>

                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.produit') }}:

                                              <span class="font-weight-bold">
                                      {{ getValue(mContract.package.description_fr) }}
                                  </span>
                                          </div>
                                      </b-col>
                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.montantAffiliation') }}:

                                              <span class="font-weight-bold">
                                      {{  getValue(mContract.package.montant) }} €
                                  </span>
                                          </div>
                                      </b-col>
                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.status') }}:

                                              <span class="font-weight-bold" v-if="getValue(mContract.status_contrat) == 'Résilié'">
                                                <span class="text-warning">{{  getValue(mContract.status_contrat) }}</span>
                                              </span>
                                              <span v-else-if="getValue(mContract.status_contrat) == 'Expiré'">
                                                <span class="text-danger">{{  getValue(mContract.status_contrat) }}</span>
                                              </span>
                                              <span v-else-if="getValue(mContract.status_contrat) == 'Renouvélé'">
                                                <span class="text-primary">{{  getValue(mContract.status_contrat) }}</span>
                                              </span>
                                               <span v-else-if="getValue(mContract.status_contrat) == 'Généré'">
                                                <span class="text-warning">{{  getValue(mContract.status_contrat) }}</span>
                                              </span>
                                              <span v-else-if="getValue(mContract.status_contrat) == 'Suspendu'">
                                                <span class="text-warning">{{  getValue(mContract.status_contrat) }}</span>
                                              </span>
                                              <span v-else>
                                                <span class="text-success">{{  getValue(mContract.status_contrat) }}</span>
                                              </span>
                                          </div>
                                      </b-col>

                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.debutAffiliation') }}:

                                              <span class="font-weight-bold">
                                      {{ formattedDate(mContract.date_debut) }}
                                  </span>
                                          </div>
                                      </b-col>
                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.finAffiliation') }}:

                                              <span class="font-weight-bold">
                                        {{ formattedDate(mContract.date_fin) }}
                                        </span>
                                          </div>
                                      </b-col>
                                  </b-row>
                                  <div>
                                      <b-col col sm="12">
                                        <div class="list-group-item">
                                            {{ $t('message.statusPaiement') }}:
                                            <span class="font-weight-bold">
                                              {{ mContract.status_paiement }}
                                            </span>
                                        </div>
                                      </b-col>
                                      <b-col col sm="12">
                                          <div class="list-group-item">
                                              {{ $t('message.urgence') }}:

                                              <span class="font-weight-bold">
                                                  {{ getValue(mContract.niveau_urgence) }}
                                              </span>
                                          </div>
                                      </b-col>
                                      <div class="list-group list-group-flush p-0" v-if="hasAssistante">
                                        <div class="card-body p-1em">
                                          <h3 class="card-title text-left mb-0">
                                              {{ $tc('message.clotureAffiliation', 2) }}
                                          </h3>
                                        </div>
                                      </div>
                                      <b-col col sm="12" v-if="hasAssistante && mContract.package.description_fr.includes('PREVENTION')">
                                        <div class="list-group-item">
                                            {{ $t('message.automatique') }}:
                                            <span class="font-weight-bold">{{ this.cloture.automatique }}</span>
                                        </div>
                                      </b-col>
                                      <b-col col sm="12" v-if="hasAssistante" >
                                        <div class="list-group-item">
                                            {{ $t('message.ama') }}:
                                            <span class="font-weight-bold">{{ formattedDateTime(this.cloture.ama) }}</span>
                                        </div>
                                        <div class="list-group-item">
                                            {{ $t('message.medecin_referent') }}:
                                            <span class="font-weight-bold">{{ formattedDateTime(this.cloture.medecin_referent) }}</span>
                                        </div>
                                        <div class="list-group-item">
                                            {{ $t('message.gestionnaire') }}:
                                            <span class="font-weight-bold">{{ formattedDateTime(this.cloture.gestionnaire) }}</span>
                                        </div>
                                      </b-col>

                                      <div class="list-group list-group-flush p-0">
                                        <!-- <div class="card-body p-1em">
                                          <h3 class="card-title text-left mb-0">
                                              {{ $tc('message.informationContrat', 2) }}
                                          </h3>
                                        </div> -->
                                          <b-col col sm="12" v-if="hasAssistante">
                                            <div class="card-body p-1em">
                                              <h3 class="card-title text-left mb-0">
                                                  {{ $tc('message.informationSouscripteur', 2) }}
                                              </h3>
                                            </div>
                                                  <div class="list-group-item">
                                                  {{ $t('message.souscripteur') }}:
                                                  <span class="font-weight-bold">
                                                      {{ mContract.souscripteur.nom+' '+mContract.souscripteur.prenom }}
                                                  </span><br>
                                                  </div>
                                                  <div class="list-group-item">
                                                  {{ $t('message.email') }}:

                                                  <span class="font-weight-bold">
                                                      {{ mContract.souscripteur.email }}
                                                  </span><br>
                                                  </div>
                                                  <div class="list-group-item">
                                                  {{ $t('message.phoneNumber') }}:

                                                  <span class="font-weight-bold">
                                                      {{ mContract.souscripteur.telephone }}
                                                  </span>
                                                  </div>
                                            </b-col>
                                          <!-- </b-row> -->
                                      </div>
                                  </div>

                              </div>
                          </b-container>
                        </b-col>
                    </b-row>

                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.cancel') + ' ' + $tc('message.contracts', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.cancel') }} contrat {{ mContract.patient.nom }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteContract">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
               
            </div>
        </div>
        <b-modal
        ref="my-modal"
        :title="mContract.package.description_fr"
        size="lg"
        header-bg-variant="success"
        header-text="light"
        hide-footer>
        <b-container class="text-center">
          <p class="">{{$t('message.moyenpaiement')}} {{ moyenPaiement }} :</p>
          <b-form-radio-group
            v-model="moyenPaiement"
            class="">
            <!-- <b-form-radio label="Mobile money" value="mtn">Mobile money</b-form-radio> -->

            <b-form-radio label="Orange money" value="orange">Orange money</b-form-radio>

            <!-- <b-form-radio label="UBA" value="uba">UBA</b-form-radio> -->

            <b-form-radio label="Carte de crédit" value="stripe">{{$t('message.creditcard')}}</b-form-radio>
          </b-form-radio-group>
        </b-container>
        <div class="row">
          <!-- <div class="col-sm-2"></div> -->
          <div class="col-sm-12" v-if="moyenPaiement == 'mtn'">
            <b-container wrap>
              <b-card class="" outlined>
                <b-container class="">
                  <div class="row">
                    <!-- <div class="col-sm-5"></div> -->
                    <div class="col-sm-12">
                      <b-img
                        align-center
                        style="margin: 0 auto"
                        height="50%"
                        src="/img/momo.jpg"
                      >
                      </b-img>
                    </div>
                    <!-- <div class="col-sm-5"></div> -->
                  </div>
                </b-container>
                <b-form ref="mtn">
                  <b-container fluid grid-list-x1>
                    <b-container wrap align-center>
                      <b-col xs12 d-col>
                        <b-form-group
                          id="lastName-group"
                          :label="$t('message.referenceDuPaiement')"
                          label-for="referenceDuPaiement"
                        >
                          <b-form-input
                            v-model="mContract.externalId"
                            color="primary"
                            :rules="[nameRules.required]"
                            :label="$t('message.referenceDuPaiement')"
                            readonly
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col xs12 d-col>
                        <b-form-group
                          id="lastName-group"
                          :label="$t('message.phone1Souscripteur')"
                          label-for="phone1Souscripteur"
                        >
                          <b-form-input
                            v-model="numeroTelephoneMtn"
                            :rules="[
                              phoneRules.required,
                              phoneRules.numeric,
                              phoneRules.min,
                              phoneRules.mtn,
                            ]"
                            color="primary"
                            :label="$t('message.phone1Souscripteur')"
                            prefix="00237"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col xs12 d-col>
                        <b-form-group>
                          <b-input-group
                            id="quantite-group"
                            :label="$t('message.quantite')"
                            label-for="quantite"
                          >
                            <b-form-input
                              type="number"
                              v-model="quantite"
                              readonly
                              min="1"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col xs12 d-col>
                        <b-form-group>
                          <b-input-group
                            id="montant-group"
                            :label="$t('message.montantSouscription')"
                            label-for="montantSouscription"
                            append="EUR"
                          >
                            <b-form-input
                              v-model="prixFinal"
                              readonly
                              color="primary"
                              :value="mContract.package.montant"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-container>
                  </b-container>
                </b-form>
                <p v-if="isLoading">{{$t('message.isloading')}}</p>
                <div class="d-flex justify-content-center" v-if="isLoading">
                    <div class="loading"></div>
                </div>
                <b-container class="align-center" v-else>
                  <div class="row">
                    <div class="col-sm-5"></div>
                    <div class="col-sm-2">
                      <b-btn
                        variant="primary"
                        :loading="loader"
                        color="primary"
                        @click="submit"
                      >
                        {{ $t("message.Paie") }}
                      </b-btn>
                    </div>
                    <!-- <div class="col-sm-5"></div> -->
                  </div>
                </b-container>
              </b-card>
            </b-container>
          </div>
          <div class="col-sm-12 pt-3" v-if="moyenPaiement == 'orange'">
            <!-- <b-card class="" raised> -->
              <b-container class="">
                <div class="row">
                  <!-- <div class="col-sm-5"></div> -->
                  <div class="col-xs-12">
                    <b-img
                      align-center
                      class="white--text align-center black-background"
                      height="50%"
                      style="background: black"
                      src="/img/orange.png"
                    ></b-img>
                  </div>
                  <!-- <div class="col-sm-5"></div> -->
                </div>
              </b-container>
              <b-form ref="orange">
                <b-container fluid grid-list-x1>
                  <b-container wrap align-center>
                    <b-col xs12 d-col>
                      <b-form-group
                        id="lastName-group"
                        :label="$t('message.referenceDuPaiement')"
                        label-for="referenceDuPaiement"
                      >
                        <b-form-input
                          v-model="mContract.externalId"
                          color="primary"
                          :rules="[nameRules.required]"
                          :label="$t('message.referenceDuPaiement')"
                          readonly
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col xs12 d-col>
                      <b-form-group
                        id="lastName-group"
                        :label="$t('message.phone1Souscripteur')"
                        label-for="phone1Souscripteur"
                      >
                        <b-form-input
                          v-model="numeroTelephoneOrange"
                          :rules="[
                            phoneRules.required,
                            phoneRules.numeric,
                            phoneRules.min,
                            phoneRules.orange,
                          ]"
                          color="primary"
                          :label="$t('message.phone1Souscripteur')"
                          prefix="00237"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col xs12 d-col>
                      <b-form-group>
                        <b-input-group
                          id="quantite-group"
                          :label="$t('message.quantite')"
                          label-for="quantite"
                        >
                          <b-form-input
                            type="number"
                            v-model="quantite"
                            readonly
                            min="1"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col xs12 d-col>
                      <b-form-group>
                        <b-input-group
                          id="montant-group"
                          :label="$t('message.montantSouscription')"
                          label-for="montantSouscription"
                          append="EUR"
                        >
                          <b-form-input
                            v-model="prixFinal"
                            readonly
                            color="primary"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-container>
                </b-container>
                <p v-if="isLoading">{{$t('message.isloading')}}</p>
                <div class="d-flex justify-content-center" v-if="isLoading">
                    <div class="loading"></div>
                </div>
                <b-container class="align-center" v-else>
                  <div class="row">
                    <!-- <div class="col-sm-5"></div> -->
                    <div class="col-sm-12  d-flex justify-content-center">
                      <b-btn
                        variant="primary"
                        :loading="loader"
                        color="primary"
                        @click="omsubmit"
                      >
                        {{ $t("message.Paie") }}
                      </b-btn>
                    </div>
                    <!-- <div class="col-sm-5"></div> -->
                  </div>
                </b-container>
              </b-form>
            <!-- </b-card> -->
          </div>
          <div class="pt-3" v-if="moyenPaiement == 'stripe'" raised>
            <!-- <b-card class="mx-auto" raised> -->
              <b-form ref="stripe">
                <b-container fluid grid-list-x1>
                  <b-container wrap align-center>
                    <b-col xs12 d-col>
                      <b-form-group>
                        <b-input-group
                          id="montant-group"
                          :label="$t('message.montantSouscription')"
                          label-for="montantSouscription"
                          append="EUR"
                        >
                          <b-form-input
                            v-model="prixFinal"
                            readonly
                            color="primary"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-container>
                </b-container>
                <p v-if="isLoading">{{$t('message.isloading')}}</p>
                <div class="d-flex justify-content-center" v-if="isLoading">
                    <div class="loading"></div>
                </div>
                <b-container class="align-center" v-else>
                  <div class="row">
                    <!-- <div class="col-sm-5"></div> -->
                    <div class="col-sm-12  d-flex justify-content-center">
                      <b-btn
                        variant="primary"
                        :loading="loader"
                        color="primary"
                        @click="goToStripe"
                      >
                        {{ $t("message.Paie") }}
                      </b-btn>
                    </div>
                    <!-- <div class="col-sm-5"></div> -->
                  </div>
                </b-container>
              </b-form>
            <!-- </b-card> -->
          </div>
          <!-- <div class="col-sm-2"></div> -->
        </div>
      </b-modal>
    </div>
    
</template>

<script>
window.$ = window.jQuery = window.jquery = require("jquery");
import {mapGetters} from "vuex";
import Vue from 'vue';
import moment from "moment";
import _ from 'lodash';
import axios from "axios";
import Swal from 'sweetalert2';
import AppConfig from "../../constants/AppConfig";
export default {
    name: "Affiliation",
    computed: {
        ...mapGetters(["subscriber", 'hasAdminRole', "countries",
                'hasGestionnaireRole','hasSouscripteurRole','hasMedecinControleRole',
                'hasPraticienRole','hasAssistante',"affiliation", "loader"]),
        mContract: function() {
          let souscripteur = JSON.parse(localStorage.getItem("user")),
              nomComplet = souscripteur["nom"] + " " + souscripteur["prenom"];
          let externalId = nomComplet + "-" + this.selectedPackage.description_fr;
          this.affiliation["externalId"] = externalId;
          if(this.affiliation.cloture){
            this.cloture = this.affiliation.cloture;
          }
          return this.affiliation;
        },
        signer: function () {
          if(this.mContract.patient != null){
            return this.mContract.patient.consentement == 1 ? true : false
          }
          return false;
        },
        today:function () {
            if (moment(this.mContract.dateSignature).isValid()){
                return moment(this.mContract.dateSignature).format('DD-MM-YYYY');
            }else{
                return moment(new Date()).format('DD-MM-YYYY');
            }
        },
    },
    data(){
        return{
            identifiant:this.$route.params.identifiant,
            perPage: 10,
            mobileView: true,
            montantSum : 0 ,
            prixFinal: 0 ,
            isLoading: false,
            offres: [],
            quantite: 1,
            prixInitial:0,
            selectedPackage:"",
            package: null,
            moyenPaiement: "",
            cloture: {},
            numeroTelephoneOrange: JSON.parse(localStorage.getItem("user"))["telephone"],
            numeroTelephoneMtn: JSON.parse(localStorage.getItem("user"))["telephone"],
            form: {
                referenceId: "",
                externalId: "",
                numeroTelephone: "",
            },
            selectedContrats: [],
            checkboxGroup: [],
            fields: [
                {
                    key: 'nomA',
                    label: this.$i18n.t('message.nomCompletAffilie'),
                },
                {
                    key: 'decede',
                    label: this.$i18n.t('message.decede'),
                },

                {
                    key: 'statutPaiement',
                    label: this.$i18n.t('message.statutDuPaiement'),
                    sortable: true,
                    formatter: 'statutPaiement'
                },
                {
                    key: 'date',
                    label: this.$i18n.tc('message.dateSignature', 1),
                    sortable: true
                },
                {
                    key: 'selected',
                    label: this.$i18n.tc('message.operations', 1)
                }
            ],
            code: "",
            nameRules: {
              required: (value) => !!value || this.$i18n.t("message.requiredField"),
              min: (v) =>
                v.length >= 9 ||
                this.$i18n.t("message.minCharacters", {
                  n: 9,
                }),
            },
            phoneRules: {
              required: (value) => !!value || this.$i18n.t("message.requiredField"),
              min: (v) =>
                v
                  ? v.length == 9 ||
                    this.$i18n.t("message.nCharacters", {
                      n: 9,
                    })
                  : true,
              numeric: (v) =>
                v ? /^[0-9]+$/gi.test(v) || this.$i18n.t("message.numeric") : true,
              orange: (v) =>
                v
                  ? /^6(9[0-9]{7})|(5[5-9]{1}[0-9]{6})$/gi.test(v) ||
                    this.$i18n.t("message.orange")
                  : true,
              mtn: (v) =>
                v
                  ? /^6((7|8)[0-9]{7})|(5[0-4]{1}[0-9]{6})$/gi.test(v) ||
                    this.$i18n.t("message.mtn")
                  : true,
            },
        }
    },
    watch: {
       prixTotal : function(){

       }
    },
    methods: {

    hasHistory () { return window.history.length > 2 },
    handleView() {
            this.mobileView = window.innerWidth < 991;
            },
    goToStripe() {
      // var stripe = Stripe(
      //   "pk_live_51Hf6FLJRvANUAsFaJCdg8V6CkkhClwXTZDGKqk7AsNUgOfIxGHyRkv2t1bnIfS61iTjIP2OIZk18W99hA0sJcCVh00R9zr6xr7"
      // );
       this.isLoading= true;
       var stripe = Stripe(AppConfig.stripe_key);
       const localToken = localStorage.getItem('ms-token');
       fetch(AppConfig.apiUrl + "/paiement/stripe-renouvellement", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
          "Authorization": "Bearer " + localToken
        },
        body: JSON.stringify({
          identifiant: this.$route.params.identifiant,
          amount: this.affiliation.package.montant,
          package_id: this.affiliation.package.id,
          quantite: 1,
          patient_id: this.affiliation.patient.user_id,
          souscripteur_id: JSON.parse(localStorage.getItem("user")).id
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (session) {
          return stripe.redirectToCheckout({
            sessionId: session.id,
          });
        })
        .then(function (result) {
          // If `redirectToCheckout` fails due to a browser or network
          // error, you should display the localized error message to your
          // customer using `error.message`.
          if (result.error) {
            alert(result.error.message);
          }
        })
        .catch(function (error) {
           this.isLoading= false;
        });
    },
    omsubmit() {
      this.isLoading = true;
      let args = {
          externalId: this.mContract.externalId,
          subscriberMsisdn: this.numeroTelephoneOrange,
          referenceId: JSON.parse(localStorage.getItem("user"))["slug"],
          identifiant: JSON.parse(localStorage.getItem("user"))["slug"],
          amount: this.affiliation.package.montant,
          quantite: this.quantite,
          package_id: this.selectedPackage.id,
          description: "Medicasure: Prolongement de l'affiliation "+this.selectedPackage.description_fr, //this.mContract.montantSouscription
        },
        patient =  this.mContract.patient.user_id;
      let self = this;
      fetch(AppConfig.apiUrl + "/paiement/om/paid", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify(args),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (result) {
          self.isLoading = false;
          if(result.reponse == undefined){
            Swal.fire(
                'ERREUR',
                "Le numéro que vous avez renseigné n'est pas correct. <br/><br/> Le format est le <b>6xxxxxxxx</b>",
                'error'
            )
          }
          else if (result.reponse.message !=undefined &&  result.reponse.message.includes('successfully')) {
            let param = {
              identifiant: JSON.parse(localStorage.getItem("user"))["slug"],
              pay_token: result.reponse.data.payToken,
              patient: patient
            };
            self.$router.push({
              name: "om-notification",
              params: param
            });
          }
          else{
            if (result.reponse.original!= undefined && result.reponse.original.erreur.includes('Le solde du compte du payeur est insuffisant')) {
              Swal.fire(
                "Echec de Paiement!",
                "Le solde du compte du payeur est insuffisant",
                "warning"
              );
            }else if(result.reponse.original!= undefined && result.reponse.original.erreur.includes('Beneficiaire introuvable')){
              Swal.fire(
                      'ERREUR',
                      "Le numéro que vous avez renseigné n'a pas de compte Orange Money. <br/><br/> Veuillez vérifier et reéssayer",
                      'error'
                  )
              }
            else{
                Swal.fire(
                    'ERREUR',
                    'Veuillez réessayer plus tard ',
                    'error'
                )
            }
          }
        })
        .catch(function (error) {
          Swal.fire(
              'ERREUR',
              'Veuillez réessayer plus tard ',
              'error'
          )
          self.isLoading = false;
        });
    },
    renewContrat(){
      this.$refs["my-modal"].show();
      this.prixFinal = this.affiliation.package.montant;
      this.prixInitial = this.affiliation.package.montant;
      this.selectedPackage = this.affiliation.package;
    },
    formattedDateTime(date) {
      if (moment(date).isValid() && date != null) {
        return moment(date).format("DD-MM-YYYY à HH:mm");
      } else {
        return date;
      }
    },

    extraContrat(){
      this.$refs["my-modal"].show();
      this.prixFinal = this.affiliation.package.montant;
      this.prixInitial = this.affiliation.package.montant;
      this.selectedPackage = this.affiliation.package;
    },
    wanToPaid() {
      this.$refs["my-modal"].show();
      this.prixFinal = this.affiliation.package.montant;
      this.prixInitial = this.affiliation.package.montant;
      this.selectedPackage = this.affiliation.package;
    },
    downloadContract() {
        let args = {
            identifiant: this.$route.params.contrat
        };

        this.$store.dispatch("printContrat", { args });
    },

    getValue(item){
        if (typeof item != "undefined"){
            return item;
        }else{
            return "";
        }
    },
    formattedDate(date) {

        return _.isNull(date) ? '': moment(date).format('DD-MM-YYYY');
    },

    updateSubscriber() {
        this.$router.push({ name: 'edit-subscriber', params: { subscriber: this.subscriber_id } });
    },

    deleteSubscriber() {
        let self = this;
        let args = {
            id: this.mContract.id,
            status: "CANCEL"
        };

        let successMessage = this.$i18n.t('message.subscriberDeleted');
        let errorMessages = {
            generic: this.$i18n.t('message.genericError'),
            error: this.$i18n.t('message.error')
        };

        this.$store.dispatch('updateAffiliationStatus', { args, successMessage, errorMessages }).then(() => {
            self.$bvModal.hide('delete-modal');
            this.$router.back();

        });
    },
    getAffiliation() {
        let args = {
            affiliation: this.$route.params.contrat
        };

        this.$store.dispatch("getAffiliation", {args})
    },
    viewMedicalFile(params){
      localStorage.setItem("dossier_medical_slug", this.affiliation.patient.dossier.slug);
      this.$router.push({ name: 'medical-file', params: { file: this.affiliation.patient.dossier.slug } });
    },
    viewTrajetPatient(params){
      localStorage.setItem("dossier_medical_slug", this.affiliation.patient.dossier.slug);
      this.$router.push(  (this.$router.resolve({ name: 'trajet-patient',  params: { file: this.affiliation.patient.dossier.slug } })).href +  '#generale');
    },
    viewConsentementPatient(){
      localStorage.setItem("dossier_medical_slug", this.affiliation.patient.dossier.slug);
      axios.get(AppConfig.apiUrl+`/consentement/${this.mContract.souscripteur.slug}/${this.mContract.patient.slug}`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}}).then(res => {
        window.open(res.data, '_blank').focus();
      });
      // console.log(this.mContract.patient.slug);
      // console.log(this.mContract.souscripteur.slug);
    },
    procederAuPaiement() {
        let contrat = []; 
        let sefl = this;

        if(sefl.selectedContrats.length != 0 && sefl.mContracts.length > 1){
            alert("Veuillez selectionner les contrats que vous souhaitez payer")
        }
        if( sefl.mContracts.length === 1){
            this.$router.push({ 
            name: 'paiement', 
            params: { 
                    identifiant: sefl.mContracts[0].contrat_code
                }
            });
        }
        else if(this.selectedContrats.length > 1){
            _.forEach(this.selectedContrats,function(item){
                contrat.push(item.contrat_code);
            })   
            this.$router.push({ 
                name: 'paiement', 
                params: { 
                    identifiant: contrat.join(',')
                    }
                });
        }
    },

    sendGuestContract() {

        let contrat = []; 
        let sefl = this;
        if(sefl.selectedContrats.length === 0){
            alert("Veuillez selectionner les contrats que vous souhaitez envoyer");
            return;
        }
        _.forEach(sefl.mContracts,function(item){

            let args = {
                identifiant: item.contrat_code
            };
            let successMessage = sefl.$i18n.t('message.contractSent');
            let errorMessages = {
                generic: sefl.$i18n.t('message.genericError'),
                error: sefl.$i18n.t('message.error')
            };

            sefl.$store.dispatch('sendGuestContract', { args, successMessage, errorMessages });
        }) 
    },

    updateContract() {
        this.$router.push({ name: 'edit-affiliation', params: { identifiant: this.identifiant } });
    },

    deleteContract() {
      let self = this;
      let args = {
          id: this.mContract.id,
          status: "Résilié"
      };

      let successMessage = this.$i18n.t('message.SubscriptionCanceled');
      let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.error')
      };

      this.$store.dispatch('updateAffiliationStatus', { args, successMessage, errorMessages }).then(() => {
          self.$bvModal.hide('delete-modal');
          this.$router.back();

      });
    },
    suspendreContract() {
        let self = this;
        let args = {
            id: this.mContract.id,
            status: "Suspendu"
        };

        let successMessage = this.$i18n.t('message.SubscriptionSuspend');
        let errorMessages = {
            generic: this.$i18n.t('message.genericError'),
            error: this.$i18n.t('message.error')
        };

        this.$store.dispatch('updateAffiliationStatus', { args, successMessage, errorMessages }).then(() => {
            self.$bvModal.hide('delete-modal');
            this.$router.back();

        });
    },
    cloturerContract(){
      let args = {
        id: this.mContract.id
      };
      axios.post(AppConfig.apiUrl+`/clotures/affiliation`, args, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}}).then(res => {
        this.cloture = res.data;
        Vue.swal("La clôture de l'affiliation par l'ama a été effectué avec succès", '', 'success');
      });

    },
    activeContract(){
      let self = this;
        let args = {
            id: this.mContract.id,
            status: "Actif"
        };

        let successMessage = this.$i18n.t('message.SubscriptionActive');
        let errorMessages = {
            generic: this.$i18n.t('message.genericError'),
            error: this.$i18n.t('message.error')
        };

        this.$store.dispatch('updateAffiliationStatus', { args, successMessage, errorMessages }).then(() => {
            self.$bvModal.hide('delete-modal');
            this.$router.back();

        });
    },

    formattedDate(date) {
        if (moment(date).isValid()){
            return moment(date).format('DD-MM-YYYY');
        }else{
            return date;
        }
    },
    onPreviewClick(value, index, item) {
        if(item.check===true){
            this.prixTotal -= parseFloat((item.montant+'').replace('.',''));
        }else{
            this.prixTotal += parseFloat((item.montant+'').replace('.',''));
        }
          
        this.selectedContrats.push(this.mContracts[index]);
        
    },
        
    },
    created() {
        this.handleView();
        window.addEventListener('resize', this.handleView);
        },
   
    mounted() {
        this.getAffiliation();
            let ckeditor = document.createElement("script");
    ckeditor.setAttribute("src", "https://js.stripe.com/v3/");
    document.head.appendChild(ckeditor);
    var isrenew = this.$route.query.renouvellement;
    if(isrenew){
                   Swal.fire(
                "Paiement du renouvellement réussi !",
                "Votre contrat a été renouvellé avec succès",
                'success'
            )
    }
    // if(!_isNull(this.$route.query.prolongation)){
    //                Swal.fire(
    //             "Paiement du renouvellement reussi !",
    //             "Votre contrat a été Prolongé avec succès, merci d'avoir choisi médicasure.",
    //             'success'
    //         )
    // }
    }
}
</script>

<style>
#modal-scoped___BV_modal_backdrop_ {
  display: none !important;
}
.modal-backdrop {
  display: none !important;
}
</style>
